<h2 mat-dialog-title>Edit HSN & GST Details</h2>
<mat-dialog-content class="mat-typography">
    <div class="table-container">
        <table class="table table-bordered edit-table">
            <thead>
                <tr>
                    <th>Category</th>
                    <th>Item/Service Name</th>
                    <th>HSN/SAC No</th>
                    <th>Specification</th>
                    <th>GST (%)</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let product of productList">
                    <ng-container *ngFor="let detail of product.details">
                        <tr>
                            <td>
                                {{
                                detail.item_service_type === 'SKU'
                                ? detail?.sku?.profit_cost_category?.category?.category_name
                                : detail.item_service_type === 'Service'
                                ? detail?.service?.profit_cost_category?.category?.category_name
                                : detail.item_service_type === 'Fixed Asset'
                                ? detail?.fa_template?.home_entity_category?.category_name
                                : ''
                                }}
                            </td>
                            <td>
                                {{
                                detail.item_service_type === 'SKU'
                                ? detail?.sku?.item?.item_name
                                : detail.item_service_type === 'Service'
                                ? detail?.service?.service_name
                                : detail.item_service_type === 'Fixed Asset'
                                ? detail?.fa_template?.name
                                : ''
                                }}
                            </td>
                            <td>
                                <ng-container>
                                    <input type="text" class="form-control select-sm" [(ngModel)]="detail.hsn_no"
                                        (ngModelChange)="onHsnChange(detail)" [matAutocomplete]="auto"
                                        placeholder="Select or Type">
                                    <mat-autocomplete #auto="matAutocomplete">
                                        <!-- SKU Options -->
                                        <ng-container *ngIf="detail.item_service_type === 'SKU'">
                                            <mat-option *ngFor="let hsn of itemHsnList" [value]="hsn.hsn_sac_no">
                                                {{ hsn.hsn_sac_no }}
                                            </mat-option>
                                        </ng-container>

                                        <!-- Service Options -->
                                        <ng-container *ngIf="detail.item_service_type === 'Service'">
                                            <mat-option *ngFor="let sac of serviceSacList" [value]="sac.hsn_sac_no">
                                                {{ sac.hsn_sac_no }}
                                            </mat-option>
                                        </ng-container>

                                        <!-- Fixed Asset Options -->
                                        <ng-container *ngIf="detail.item_service_type === 'Fixed Asset'">
                                            <mat-option *ngFor="let fa of fixedAssetHsnList" [value]="fa.hsn_sac_no">
                                                {{ fa.hsn_sac_no }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-autocomplete>
                                </ng-container>
                            </td>

                            <td>
                                <input matInput type="text" class="form-control input-sm"
                                    [(ngModel)]="detail.specification" placeholder="Specification">
                            </td>
                            <td>
                                <select class="form-control select-sm" [(ngModel)]="detail.taxType"
                                    (ngModelChange)="onTaxChange(detail)">
                                    <option [value]="null">Select GST</option>
                                    <option *ngFor="let opt of taxOptions" [value]="opt.global_gst_id">
                                        {{ opt.gst_name }}%
                                    </option>
                                </select>

                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button class="btn btn-danger" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" class="btn btn-success" (click)="onSave()">Update Table</button>
</mat-dialog-actions>